import angular from "angular";

angular
    .module('app')
    .component('videosControl', {
        template: require('./videos-control.html'),
        controller: ['Upload', '$uibModal', 'Notifier', '$http', controller],
        bindings: {}
    });

function controller(Upload, $uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = 10;
    $ctrl.search = null;
    $ctrl.courses = [];

    $ctrl.$onInit = function () {
        $ctrl.getVideos();
        $ctrl.getCoursesList();

    };

    $ctrl.openUploadForm = function (folder) {
        $uibModal
            .open({
                component: 'videosUploadModal',
                keyboard: false,
                backdrop: 'static',
                size: 'lg'
            })
            .result
            .then(
                function (videos) {
                    if (videos !== null) {
                        angular.forEach(videos, function (video) {
                            $ctrl.videos.unshift(video);
                        })
                    } else {

                    }
                },
                function () {

                }
            );
    };

    $ctrl.getCoursesList = function () {
        $http
            .get('/admin/videos/get-courses-list')
            .then(
                function (response) {
                    $ctrl.courses = response.data;
                },
                function (error) {
                }
            );
    };

    $ctrl.doFilter = function (course) {
        if (course != null) {
            $ctrl.search = course.id;
        } else {
            $ctrl.search = null;
        }
        $ctrl.getVideos();
    };

    $ctrl.getVideos = function () {
        $ctrl.loading = true;
        $ctrl.videos = null;
        $http
            .get(`/admin/videos/get-videos`, {
                params: {
                    search: $ctrl.search,
                    per_page: $ctrl.perPage,
                    page: $ctrl.page
                }
            })
            .then(
                function (response) {
                    $ctrl.videos = response.data.data;
                    $ctrl.total = response.data.total;
                    $ctrl.loading = false;
                },
                function (error) {
                    $ctrl.loading = false;
                }
            )
    };

    $ctrl.delVideo = function (video) {
        $http.post(`/admin/videos/${video.id}/delete`)
            .then(
                function (res) {
                    Notifier.success('Видео удалено',2);
                    window.location = `/admin/videos`;
                },
                function (error) {
                    Notifier.error(error);
                })
    }
}
